import AJAX from 'common/AJAX';
import { useOnboardingContext } from 'common/containers/OnboardingContainer';
import useMutation, { type MutationOptions } from 'common/hooks/useMutation';

import type { OnboardingResponse, OnboardingUpdateData } from 'common/api/endpoints/onboarding';

export const useUpdateOnboarding = (
  options?: MutationOptions<OnboardingResponse, Partial<OnboardingUpdateData>>,
) => {
  const { upsertOnboarding } = useOnboardingContext();

  return useMutation<OnboardingResponse, Partial<OnboardingUpdateData>>({
    mutationFn: async (input) => {
      const response = await AJAX.post('/api/onboarding/update', input);
      return response;
    },
    isResponseSuccessful: (response) => 'onboarding' in response,
    ...options,
    onSuccess: (data, variables) => {
      upsertOnboarding(data.onboarding);

      options?.onSuccess?.(data, variables);
    },
  });
};
